module.exports = __webpack_public_path__ + "96598f00c2e11675f436c05d73a105e9.pdf";